"use strict";

function getIndexWithSelector(el, selector) {
    let index = 0,
        matches = el.parentNode.querySelectorAll(selector);
    
    if(matches.length == 0) return false;
    
    for(let i = 0; i < matches.length; i++) {
        if(matches[i] == el) break;
        index++;
    }
    return index;
}

function scrollBack(slider) {
	let vertical =
		slider.classList.contains("slider--vertical") ||
		(slider.classList.contains(
			"slider--vertical-on-desktop"
		) &&
			window.innerWidth > 900);

	slider.classList.add("scrolling-back");
	
	setTimeout(() => {
		if (vertical) slider.scrollTop = 0;
		else slider.scrollLeft = 0;
	}, 0);

	setTimeout(
		() => slider.classList.remove("scrolling-back"),
		10
	);
}

window.addEventListener("load", () => {
	const sliders = document.querySelectorAll(".slider");

	let observer = new IntersectionObserver(
		function (entries) {
			entries.forEach((entry) => {
				if (entry.intersectionRatio > 0) {
					observer.unobserve(entry.target);
					scrollBack(entry.target);
					setTimeout(() => {
						checkSlider(entry.target)
					}, 20);
				}
			});
		},
		{ threshold: 0, rootMargin: "0px" }
	);

	sliders.forEach((slider) => observer.observe(slider));
});

window.addEventListener("click", (e) => {
	if (e.target.classList.contains("slider__control")) {
		let wrapper = e.target.closest(".slider__wrapper");
		if(!wrapper) return;
		e.preventDefault();
		let gap = 0;
		let slideNum = 1;
		if (wrapper.hasAttribute("data-gap"))
			gap = Number(wrapper.getAttribute("data-gap"));
		if (wrapper.hasAttribute("data-slide"))
			slideNum = Number(wrapper.getAttribute("data-slide"));
		if (window.innerWidth <= 900 && wrapper.hasAttribute("data-slide-mob"))
			slideNum = Number(wrapper.getAttribute("data-slide-mob"));
		let slider = wrapper.querySelector(".slider");
		let firstSlide = slider.querySelector(".slider__slide");

		if (!firstSlide) firstSlide = slider.querySelector("*");

		let slideWidth = firstSlide.offsetWidth;
		let currentScroll = slider.scrollLeft;
		let maxScroll = slider.scrollWidth - slider.clientWidth;

		let maxPage = Math.round(maxScroll / slideWidth);
		let currentPage = Math.round(currentScroll / slideWidth);

		if (e.target.classList.contains("slider__control--next")) {
			
			if (currentPage < maxPage) {
				currentPage += slideNum;
				currentScroll = currentPage * slideWidth + gap;
				slider.scrollLeft = currentScroll;
			} else if (currentPage > maxPage) {
				currentPage = maxPage;
				currentScroll = maxScroll;
				slider.scrollLeft = maxScroll;
			} else {
				currentScroll = maxScroll;
				slider.scrollLeft = maxScroll;
			}
		} else if (e.target.classList.contains("slider__control--prev")) {
			if (currentScroll > 0) currentPage -= slideNum;
			if (currentPage < 0) currentPage = 0;

			currentScroll = currentPage * slideWidth - gap;
			slider.scrollLeft = currentScroll;
		}

		if (maxScroll - currentScroll < 20) {
			wrapper.classList.add("slider__wrapper--end");
			wrapper.classList.remove("slider__wrapper--start");
		} else {
			wrapper.classList.remove("slider__wrapper--end");
		}

		if (currentPage == 0) {
			wrapper.classList.add("slider__wrapper--start");
			wrapper.classList.remove("slider__wrapper--end");
		} else wrapper.classList.remove("slider__wrapper--start");
	}
});

function moveToSlide(slider, currentPage = 0, sliderCheckNum = 0) {
	// if(currentPage > 0) currentPage--;

	let wrapper = slider.closest(".slider__wrapper");
	let gap = 0;
	if (wrapper.hasAttribute("data-gap"))
		gap = Number(wrapper.getAttribute("data-gap"));
	const slides = slider.querySelectorAll(".slider__slide");
	let firstSlide = slides[sliderCheckNum];
	let vertical =
		slider.classList.contains("slider--vertical") ||
		(slider.classList.contains("slider--vertical-on-desktop") &&
			window.innerWidth > 900);

	let maxScroll = 0;

	if (vertical) maxScroll = slider.scrollHeight - slider.clientHeight;
	else maxScroll = slider.scrollWidth - slider.clientWidth;

	if (maxScroll == 0) return;

	if (!firstSlide) firstSlide = slider.querySelector("*");

	let slideWidth = 0;

	if (vertical) {
		slideWidth = firstSlide.offsetHeight;
	} else {
		slideWidth = firstSlide.offsetWidth;
	}

	let currentScroll = (slideWidth + gap) * currentPage;

	if (vertical) {
		slider.scrollTop = currentScroll;
	} else {
		slider.scrollLeft = currentScroll;
	}

	if (maxScroll - currentScroll < 20) {
		wrapper.classList.add("slider__wrapper--end");
		wrapper.classList.remove("slider__wrapper--start");
	} else {
		wrapper.classList.remove("slider__wrapper--end");
	}

	if (currentPage == 0) {
		wrapper.classList.add("slider__wrapper--start");
		wrapper.classList.remove("slider__wrapper--end");
	} else wrapper.classList.remove("slider__wrapper--start");
}

function sliderThumbClick(thumb, indexFilter = false, sliderCheckNum = 0) {
	const slider = thumb.closest(".slider");
	const actives = slider.querySelectorAll(".slider__slide--selected");
	if (actives.length > 0)
		actives.forEach((active) =>
			active.classList.remove("slider__slide--selected")
		);

	thumb.classList.add("slider__slide--selected");

	let index = getIndexWithSelector(thumb, ".slider__slide");
	if (indexFilter !== false) index = indexFilter(index);

	const targetSlider = document.querySelector(slider.getAttribute("data-nav-for"));

	if(targetSlider.classList.contains('slider--infinite')) index += slider.querySelectorAll('.slider__slide').length;

	moveToSlide(
		targetSlider,
		index,
		sliderCheckNum
	);
}

function sliderGoTo(slider, index, slideWidth = false, no_animation = false) {
	if(slideWidth === false) {
		slideWidth = slider.querySelector('.slider__slide').offsetWidth;
	}

	// console.log(slider, index, slideWidth);

	if(no_animation) {
		slider.classList.add("scrolling-back");
		setTimeout(() => (slider.scrollLeft = slideWidth * index), 10);
		setTimeout(() => slider.classList.remove("scrolling-back"), 30);
	} else {
		slider.scrollLeft = slideWidth * index;
	}
}

// function sliderSetupInfinite(slider) {
// 	const slides = slider.querySelectorAll('.slider__slide:not(.slider__slide--duplicate)');
// 	if(!slides) return false;

// 	let prependedChild = false;
// 	slides.forEach(slide => {
// 		const cloneAfter = slide.cloneNode(true);
// 		cloneAfter.classList.add('slider__slide--duplicate');
// 		if(cloneAfter.hasAttribute('id')) cloneAfter.setAttribute('id', 'dpla-' + cloneAfter.getAttribute('id'));
// 		slider.append( cloneAfter );
		
// 		const cloneBefore = slide.cloneNode(true);
// 		cloneBefore.classList.add('slider__slide--duplicate');
// 		if(cloneBefore.hasAttribute('id')) cloneBefore.setAttribute('id', 'dplb-' + cloneBefore.getAttribute('id'));
// 		if(prependedChild === false) {
// 			slider.prepend( cloneBefore );
// 		} else {
// 			prependedChild.after(cloneBefore);
// 		}
// 		prependedChild = cloneBefore;
// 	});

// 	sliderGoTo(slider, slides.length, slides[0].offsetWidth, true);
// }

function checkSlider(slider, sliderCheckNum = 0, indexFilter = false) {
	if (!slider) return;

	let wrapper = slider.closest(".slider__wrapper");
	if (!wrapper) return;

	const slides = slider.querySelectorAll(".slider__slide:not(.slider__slide--duplicate)");
	
	let firstSlide = slides[sliderCheckNum];
	if (!firstSlide) firstSlide = slider.querySelector("*");
	if (!firstSlide) return;
	let slideWidth = 0;
	let vertical =
		slider.classList.contains("slider--vertical") ||
		(slider.classList.contains("slider--vertical-on-desktop") &&
			window.innerWidth > 900);

	let infinite = slider.classList.contains('slider--infinite');

	let currentScroll = 0;
	let maxScroll = 0;

	if (vertical) {
		currentScroll = Math.ceil(slider.scrollTop);
		maxScroll = slider.scrollHeight - slider.clientHeight;
		slideWidth = firstSlide.offsetHeight;
	} else {
		currentScroll = Math.ceil(slider.scrollLeft);
		maxScroll = slider.scrollWidth - slider.clientWidth;
		slideWidth = firstSlide.offsetWidth;
	}

	let maxPage = Math.round(maxScroll / slideWidth);
	let currentPage = Math.round(currentScroll / slideWidth);
	if (isNaN(currentPage)) currentPage = 0;

	if (!wrapper.classList.contains("slider__wrapper--loaded")) {

		if (slider.classList.contains("slider-nav")) {
			slider.addEventListener("click", (e) => {
				if (e.target.classList.contains("slider__slide"))
					sliderThumbClick(e.target);
				else if(e.target.parentNode.classList.contains("slider__slide")) {
					sliderThumbClick(e.target.parentNode);
				}
			});
		}

		if(infinite && maxScroll > 0) sliderSetupInfinite(slider);

		if(maxScroll > 0) slider.addEventListener(
			"scroll",
			function () {
				const thisSlider = this;
				if (sliderThrottle !== false) clearTimeout(sliderThrottle);
				sliderThrottle = setTimeout(() => {
					let currentScroll = Math.ceil(slider.scrollLeft);
					let firstSlide = slider.querySelector(".slider__slide");
					let slideWidth = firstSlide.offsetWidth;
					let currentPage = Math.round(currentScroll / slideWidth);

					let event = new CustomEvent("sliderUpdate", {
						bubbles: true,
						detail: {
							slider: thisSlider,
							slideNumber: currentPage
						}
					});
					document.dispatchEvent(event);

					checkSlider(thisSlider, sliderCheckNum, indexFilter);
				}, 40);
			},
			{ passive: true }
		);

		if (slider.hasAttribute("data-autoslide")) {
			let autoslide = Number(slider.getAttribute("data-autoslide"));
			if (!isNaN(autoslide)) runSlider(slider, autoslide);
		}

		wrapper.classList.add("slider__wrapper--loaded");
	}

	if (maxScroll == 0) {
		wrapper.classList.add("slider__wrapper--end");
		wrapper.classList.add("slider__wrapper--start");
		return;
	}

	if (slider.hasAttribute("data-nav")) {
		let nav = document.querySelector(slider.getAttribute("data-nav"));
		if (nav) {
			checkSlider(nav);

			let actives = nav.querySelectorAll(".slider__slide--selected");
			if (actives.length > 0)
				actives.forEach((active) =>
					active.classList.remove("slider__slide--selected")
				);

			let activate = nav.querySelectorAll(".slider__slide");

			if (indexFilter !== false)
				activate[indexFilter(currentPage)].classList.add(
					"slider__slide--selected"
				);
			else {
				if(activate.length == currentPage) activate[0].classList.add("slider__slide--selected");
				else activate[currentPage % slides.length].classList.add("slider__slide--selected");
			}
		}
	}

	let dots = wrapper.querySelectorAll(".slider__dot:not(.slider__slide)");
	if (dots.length) {
		for (let i = 0; i < dots.length; i++)
			dots[i].classList.remove("slider__dot--active");
		
		dots[currentPage % slides.length].classList.add("slider__dot--active");
	}

	if(infinite) {
		if(currentPage < slides.length) {
			sliderGoTo(slider, currentPage + slides.length, slideWidth, true);
		} else if(currentPage >= slides.length * 2) {
			sliderGoTo(slider, currentPage - slides.length, slideWidth, true);
		}
		
		return;
	}

	if (maxScroll - currentScroll < 20) {
		wrapper.classList.add("slider__wrapper--end");
		if(slider.classList.contains('slider--overflow')) {
			scrollBack(slider);
			checkSlider(slider);
		}
	} else wrapper.classList.remove("slider__wrapper--end");

	if (currentPage == 0) wrapper.classList.add("slider__wrapper--start");
	else wrapper.classList.remove("slider__wrapper--start");
}

let sliderThrottle = false;
// let sliderDotsThrottle = false;

function runSlider(slider, autoslide) {
	setInterval(function () {
		let wrapper = slider.closest(".slider__wrapper");
		// if (wrapper.matches(":hover")) return;

		let vertical =
			slider.classList.contains("slider--vertical") ||
			(slider.classList.contains("slider--vertical-on-desktop") &&
				window.innerWidth > 900);
		let slideWidth = 0;
		let currentScroll = slider.scrollLeft;
		if (vertical) currentScroll = slider.scrollTop;

		let maxScroll = 0;

		if (vertical) {
			maxScroll = slider.scrollHeight - slider.clientHeight;
			slideWidth = slider.offsetHeight;
		} else {
			maxScroll = slider.scrollWidth - slider.clientWidth;
			slideWidth = slider.querySelector('.slider__slide').offsetWidth;
		}

		let gap = 0;
		if (wrapper && wrapper.hasAttribute("data-gap"))
			gap = Number(wrapper.getAttribute("data-gap"));

		let maxPage = Math.round(maxScroll / slideWidth);
		let currentPage = Math.round(currentScroll / slideWidth);

		currentPage++;

		if (currentPage > maxPage) {
			currentPage = 0;
		}

		if (vertical) slider.scrollTop = currentPage * slideWidth + gap;
		else {
			slider.scrollLeft = currentPage * slideWidth + gap;
		}

		// if (currentPage >= maxPage) {
		// 	currentPage = 0;
		// 	setTimeout(function () {
		// 		// slider.classList.add("scrolling-back");
		// 		if (vertical) setTimeout(() => (slider.scrollTop = 0), 50);
		// 		else setTimeout(() => (slider.scrollLeft = 0), 50);
		// 		// setTimeout(() => slider.classList.remove("scrolling-back"), 50);
		// 	}, 1000);
		// }
	}, autoslide * 1000);
}

function activate_dots(selector) {
	let sliderDots;
	if(selector) {
		sliderDots = selector;
	} else {
		sliderDots = document.querySelectorAll(".slider__wrapper .slider__dot, .slider .slider__dot, [nav-for] > .slider__dot");
	}
	sliderDots.forEach(sliderDot =>
		sliderDot.addEventListener("click", e => {
			let slider, dots_container;

			const dot = e.target.closest('.slider__dot');
			if(dot.parentElement.hasAttribute('nav-for')) {
				dots_container = dot.parentElement;
				slider = document.querySelector(dot.parentElement.getAttribute('nav-for'));
				if(!slider) return;
			} else {
				let wrapper = dot.closest(".slider__wrapper");
				if (!wrapper) return;
				slider = wrapper.querySelector(".slider");
				dots_container = wrapper;
			}

			let index = 0;
			let dots = dots_container.querySelectorAll(".slider__dot");

			for (let i = 0; i < dots.length; i++) {
				if (dots[i] == dot) {
					index = i;
					dots[i].classList.add("slider__dot--active");
				} else dots[i].classList.remove("slider__dot--active");
			}

			sliderGoTo(slider, index);
		})
	)
}

activate_dots(false);